import {Button, Modal} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useWizard, Wizard} from "react-use-wizard";
import {setSelectedPrimerPos} from "../../../../../_reducers/DataPanel/Clients/clientSlice";
import {toast} from "react-toastify";
import axios from "axios";
import {MdCancel} from "react-icons/md";
import "react-image-gallery/styles/css/image-gallery.css";
import PrimerPosConfigurationStep from "./primer-pos-configuration-step";
import {stepContentMap} from "./primer-pos-configuration-steps";

const StepFooter = ({completeStep, steps, setShow, cancelStepCompletion, selectedPos}) => {
    const { isFirstStep, isLastStep, previousStep, nextStep, activeStep } = useWizard();
    const selectedStep = steps?.find((el, id) => id === activeStep);
    const [loader, setLoader] = useState(false);
    return (
        <div className="d-flex justify-content-between">
            <Button variant="outline-danger" disabled={isFirstStep || loader} onClick={previousStep}>
                Προηγούμενο Βήμα
            </Button>
            <div className={"align-items-end"}>
                {selectedStep?.status === "completed" ? (
                    <React.Fragment>
                        <Button className={"mr-2"} variant="outline-danger" disabled={loader || (selectedPos?.status !== "available" && selectedPos?.status !== "purchased" && selectedPos?.status !== "notAvailable")} onClick={() => cancelStepCompletion(selectedStep, setLoader)}>
                            Ακύρωση Ολοκλήρωσης {loader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                        </Button>
                        <Button variant="primary" disabled={loader} onClick={() => {
                            if(isLastStep) {
                                setShow(false);
                            } else {
                                nextStep();
                            }
                        }}>
                            {isLastStep ? "Κλείσιμο Παραμετροποίησης" : "Επόμενο Βήμα"}
                        </Button>
                    </React.Fragment>
                ) : (
                  <React.Fragment>
                      <Button className={"mr-2"} variant="outline-primary" disabled={loader} onClick={() => {
                          if(isLastStep) {
                              setShow(false);
                          } else {
                              nextStep();
                          }
                      }}>
                          {isLastStep ? "Κλείσιμο Παραμετροποίησης" : "Παράλειψη Βήματος"}
                      </Button>
                      <Button variant="primary" disabled={loader || (selectedPos?.status !== "available" && selectedPos?.status !== "purchased" && selectedPos?.status !== "notAvailable")} onClick={() => completeStep(activeStep, nextStep, setLoader, isLastStep)}>
                          {"Ολοκλήρωση Βήματος "}
                          {loader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                      </Button>
                  </React.Fragment>
                )}
            </div>
        </div>
    );
};

const WizardHeader = ({ steps }) => {
    const { activeStep, goToStep } = useWizard();

    return (
        <div className="wizard-header d-flex justify-content-center align-items-center mb-4">
            {steps.map((step, idx) => {
                const isActive = idx === activeStep;
                const isCompleted = step?.status === "completed";
                const title = stepContentMap[step.code].title;
                const isPassed = !isActive && idx < activeStep;

                return (
                    <div className="d-flex align-items-center" key={`step_${step.id}`}>
                        <div
                            style={{minHeight: "80px", minWidth: "9.5vw"}}
                            className={`step-box ${(isCompleted && !isActive) ? "completed" : isPassed ? "passed" : ""} ${isActive ? "active" : ""}`}
                            onClick={() => goToStep(idx)}>
                            <div className="step-number">{stepContentMap[step.code].icon}</div>
                            <div className="step-label">{isCompleted ? "✓" : isPassed ? <MdCancel size={17} /> : ""} {title}</div>
                        </div>
                        {idx < steps.length - 1 && <div className="step-connector" />}
                    </div>
                );
            })}
        </div>
    );
};

export const PrimerPosConfigurationModal = ({show, setShow}) => {
    const selectedPos = useSelector((state) => state.CLIENTS_DATA.selectedPrimerPos);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const dispatch = useDispatch();
    const [startIndex, setStartIndex] = useState(0);
    const steps = selectedPos?.configurationSteps || [];

    useEffect(() => {
        if(show && selectedPos) {
            const foundIndex = steps?.findIndex((el) => el.status === "open");
            setStartIndex(foundIndex !== -1 ? (foundIndex + 1) : steps.length);
        } else {
            setStartIndex(0);
        }
    }, [show]);

    const onComplete = () => {
        console.log("Wizard complete!");
        setShow(false);
    };

    const saveNotes = (step, setLoader) => {
        if(step) {
            setLoader(true);
            console.log(step.notes)
            const reqData = {company: company.id, posId: selectedPos._id, stepCode: step.code, action: "saveNotes", notes: step.notes};
            axios.post(`${process.env.REACT_APP_API_URL2}/client/primer-pos-edit-step`, reqData, {
                headers: { 'Content-Type': 'application/json' },
            }).then((res) => {
                setLoader(false);
                if (res.data.status === "200") {
                    dispatch(setSelectedPrimerPos(res.data.data));
                    toast.success("Επιτυχής Αποθήκευση Σημειώσεων!");
                } else {
                    toast.error(res.data.message);
                }
            }).catch((err) => {
                setLoader(false);
                console.log(err);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            })
        } else {
            toast.error("Το Βήμα δεν βρέθηκε!");
        }
    }

    const cancelStepCompletion = (step, setLoader) => {
        if(step) {
            setLoader(true);
            console.log(step.notes)
            const reqData = {company: company.id, posId: selectedPos._id, stepCode: step.code, action: "cancel"};
            axios.post(`${process.env.REACT_APP_API_URL2}/client/primer-pos-edit-step`, reqData, {
                headers: { 'Content-Type': 'application/json' },
            }).then((res) => {
                setLoader(false);
                if (res.data.status === "200") {
                    dispatch(setSelectedPrimerPos(res.data.data));
                    toast.success("Επιτυχής Ακύρωση Ολοκλήρωσης Βήματος!");
                } else {
                    toast.error(res.data.message);
                }
            }).catch((err) => {
                setLoader(false);
                console.log(err);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            })
        } else {
            toast.error("Το Βήμα δεν βρέθηκε!");
        }
    }

    const completeStep = (activeStep, nextStep, setLoader, isLastStep) => {
        const selectedStep = steps?.find((el, id) => id === activeStep);
        if(selectedStep) {
            setLoader(true);
            const reqData = {company: company.id,posId: selectedPos._id, stepCode: selectedStep.code, action: "complete"};
            axios.post(`${process.env.REACT_APP_API_URL2}/client/primer-pos-edit-step`, reqData, {
                headers: { 'Content-Type': 'application/json' },
            }).then((res) => {
                setLoader(false);
                if (res.data.status === "200") {
                    dispatch(setSelectedPrimerPos(res.data.data));
                    const isCompleted = res?.data?.data?.configurationSteps?.every((el) => el.status === "completed");
                    toast.success(isCompleted ? "Επιτυχής Ολοκλήρωση Παραμετροποίησης!" : "Επιτυχής Ολοκλήρωση Βήματος!");
                    if(isCompleted) {
                        setShow(false);
                    } else {
                        nextStep();
                    }
                } else {
                    toast.error(res.data.message);
                }
            }).catch((err) => {
                setLoader(false);
                console.log(err);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            })
        } else {
            toast.error("Το Βήμα δεν βρέθηκε!");
        }
    }

    const handleOnChangeStep = (stepCode, key, value) => {
        if (selectedPos?.configurationSteps) {
            const updatedSteps = selectedPos.configurationSteps.map((step) => step.code === stepCode ? { ...step, [key]: value } : step);
            dispatch(setSelectedPrimerPos({...selectedPos, configurationSteps: updatedSteps}));
        } else {
            toast.error("Κάτι πήγε στραβά!");
        }
    };

    return (
        <Modal backdrop="static" className="themeModalVeryBig" show={show} onHide={() => setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Παραμετροποίηση Συσκευής POS (SN:{selectedPos?.serialNumber}, Κωδικός Διαχειριστή: {selectedPos?.serialNumber?.slice(-6)}*!#@%)</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{height: "90vh", display: "flex", flexDirection: "column", overflowY: "auto"}}>
                {startIndex !== 0 && (
                    <Wizard
                        startIndex={Number(startIndex - 1)}
                        onComplete={onComplete}
                        header={<WizardHeader steps={steps} />}
                        style={{ flex: 1, display: "flex", flexDirection: "column" }}
                        footer={<StepFooter completeStep={completeStep} steps={steps} setShow={setShow} selectedPos={selectedPos} cancelStepCompletion={cancelStepCompletion} />}>
                        {steps.map((step, index) => (
                            <PrimerPosConfigurationStep key={`bigStep_${index}`} onChange={handleOnChangeStep} step={step} selectedPos={selectedPos} saveNotes={saveNotes} />
                        ))}
                    </Wizard>
                )}
            </Modal.Body>
        </Modal>
    );
}